// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"c2db81a3a04df3fe326c","266":"47f2929b6c61769ed2c2","757":"506ffb4d4594d56beed5","825":"e5504bcaf233caad18e9"}[chunkId] + ".css";
};